// ---------------------------------------------
// auto-generated from materia/hub.jsx
// edit the source there and run `npm run sync`
// ---------------------------------------------
import React from "react";
import { MChip, MEye, MNotAdvice, MChart, MRail, MTopBar, MConceptGraph } from "./prims.jsx";
import { Icon } from "../screens-cristal/primitives.jsx";

export const ScreenMHub = () => {
  const conceptNodes = [
    { k: "vela",    x: 30,  y: 80,  t: "Vela / OHLC", s: "done" },
    { k: "vol",     x: 90,  y: 40,  t: "Volumen", s: "done" },
    { k: "tf",      x: 90,  y: 140, t: "Timeframe", s: "done" },
    { k: "tend",    x: 150, y: 80,  t: "Tendencia", s: "now" },
    { k: "sr",      x: 210, y: 40,  t: "S/R", s: "next" },
    { k: "rupt",    x: 210, y: 130, t: "Ruptura", s: "next" },
  ];
  const conceptEdges = [[0,3],[1,3],[2,3],[3,4],[3,5]];

  return (
    <div className="m-screen-d materia" data-screen-label="Hub · Hoy">
      <div style={{ display: "flex", height: "100%", position: "relative", zIndex: 1 }}>
        <MRail active="today"/>
        <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
          <MTopBar crumbs={["EducaFinaz", "Hoy"]}/>

          <div style={{ flex: 1, padding: "26px 40px 0", overflow: "hidden" }}>
            {/* Hero */}
            <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between" }}>
              <div>
                <MEye>Lunes · 17 may · 14:32 UTC</MEye>
                <div style={{ fontSize: 36, fontWeight: 600, letterSpacing: "-0.025em", marginTop: 6, lineHeight: 1.05 }}>
                  Buenos días, Marta.
                </div>
                <div className="m-serif" style={{ fontSize: 18, color: "var(--m-text-2)", marginTop: 6 }}>
                  Hoy aprenderás a distinguir una ruptura de una falsa ruptura.
                </div>
              </div>
              <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <MChip variant="copper">racha · 12 días</MChip>
                <MChip variant="neutral">nivel · medio</MChip>
                <MChip variant="warn">repaso · 3</MChip>
              </div>
            </div>

            {/* Grid */}
            <div style={{
              marginTop: 22, display: "grid",
              gridTemplateColumns: "minmax(0,1.45fr) minmax(0,1fr)",
              gridTemplateRows: "auto auto",
              gap: 18,
            }}>
              {/* Continue */}
              <div className="m-panel" style={{ padding: 20, gridRow: "span 2", display: "flex", flexDirection: "column" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <MEye>Continúa donde lo dejaste</MEye>
                  <div style={{ display: "flex", gap: 6 }}>
                    <MChip>EXPLICA · 7 min</MChip>
                    <MChip variant="neutral">acto 3 de 7</MChip>
                    <MChip variant="live">live case</MChip>
                  </div>
                </div>

                <div style={{ fontSize: 26, fontWeight: 600, lineHeight: 1.15, letterSpacing: "-0.02em", marginTop: 10 }}>
                  Soportes, resistencias y volumen.
                </div>
                <div style={{ fontSize: 13.5, color: "var(--m-text-2)", marginTop: 6, textWrap: "pretty" }}>
                  Aprende a distinguir cruce, cierre y confirmación. El acto 3 espera con tu cierre fuera de zona.
                </div>

                <div style={{ marginTop: 16, flex: 1, minHeight: 0 }}>
                  <MChart width={680} height={300} caption="XYZ · 1D · 60 sesiones"
                    overlays={[
                      { type: "zone", topPct: 30, bottomPct: 38, color: "copper", label: "ZONA R" },
                      { type: "marker", xPct: 60, yPct: 26, label: "cierre fuera", kind: "decision" },
                      { type: "hline", yPct: 60, color: "rgba(216,196,160,0.3)", dashed: true, label: "S" },
                    ]}/>
                </div>

                <div style={{ marginTop: 18, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 10, flex: 1 }}>
                    <div style={{ flex: 1, maxWidth: 360, height: 4, background: "rgba(216,196,160,0.1)", borderRadius: 4, overflow: "hidden" }}>
                      <div style={{ width: "42%", height: "100%", background: "linear-gradient(90deg, var(--m-primary), var(--m-accent))" }}/>
                    </div>
                    <span className="mono" style={{ fontSize: 11, color: "var(--m-text-3)" }}>02:54 / 07:00 · 4 ejercicios</span>
                  </div>
                  <div style={{ display: "flex", gap: 8 }}>
                    <button className="m-btn"><Icon name="book" size={14}/> Leer</button>
                    <button className="m-btn primary"><Icon name="play" size={14}/> Reanudar</button>
                  </div>
                </div>
              </div>

              {/* Today's mission */}
              <div className="m-panel" style={{ padding: 20 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <MEye>Misión de hoy</MEye>
                  <MChip variant="copper">FLASH · 20s</MChip>
                </div>
                <div style={{ fontSize: 20, fontWeight: 600, marginTop: 10, lineHeight: 1.2, letterSpacing: "-0.02em" }}>
                  Una tendencia no es una línea recta.
                </div>
                <div style={{ fontSize: 12.5, color: "var(--m-text-2)", marginTop: 6 }}>
                  Microacción · tap-select sobre 4 swings · iniciación
                </div>
                <div style={{ marginTop: 14 }}>
                  <MChart width={460} height={120} caption="" ohlcLabel={false} showVolume={false}
                    yLabels={[]} xLabels={[]} withGrid={false}
                    overlays={[
                      { type: "swing", xPct: 16, yPct: 70, label: "HL" },
                      { type: "swing", xPct: 38, yPct: 56, label: "HL" },
                      { type: "swing", xPct: 60, yPct: 38, label: "HH" },
                      { type: "swing", xPct: 82, yPct: 28, label: "HH" },
                    ]}/>
                </div>
                <button className="m-btn accent" style={{ marginTop: 14, width: "100%" }}>
                  <Icon name="play" size={14}/> Empezar misión de hoy
                </button>
              </div>

              {/* Spaced review queue */}
              <div className="m-panel" style={{ padding: 20 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <MEye>Repaso pendiente · 3 cards</MEye>
                  <a style={{ fontSize: 11, color: "var(--m-text-3)", textDecoration: "none" }} className="mono">ver todo →</a>
                </div>
                <div style={{ marginTop: 12, display: "flex", flexDirection: "column", gap: 8 }}>
                  {[
                    { t: "Tendencia ≠ vela aislada", d: "día 3 · flashcard", c: "var(--m-positive)" },
                    { t: "Soporte es zona, no línea", d: "día 4 · micro-quiz", c: "var(--m-accent)" },
                    { t: "RSI alto no significa vender", d: "día 10 · transferencia", c: "var(--m-primary)" },
                  ].map((c, i) => (
                    <div key={i} style={{
                      display: "flex", alignItems: "center", gap: 12,
                      padding: "10px 12px", borderRadius: 6,
                      background: "var(--m-bg-deep)",
                      border: "1px solid var(--m-line)",
                      borderLeft: `2px solid ${c.c}`,
                    }}>
                      <Icon name="lightbulb" size={14} style={{ color: c.c }}/>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 13, fontWeight: 500, lineHeight: 1.25 }}>{c.t}</div>
                        <div className="mono" style={{ fontSize: 10, color: "var(--m-text-3)", marginTop: 2 }}>{c.d}</div>
                      </div>
                      <Icon name="next" size={14} style={{ color: "var(--m-text-3)" }}/>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Path map row */}
            <div style={{ marginTop: 18, display: "grid", gridTemplateColumns: "minmax(0,1.45fr) minmax(0,1fr)", gap: 18 }}>
              <div className="m-panel" style={{ padding: 18 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                  <MEye>Tu ruta · AT iniciación</MEye>
                  <MChip variant="neutral">curso 2 de 5 · 22% completado</MChip>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  {[
                    { l: "M1", t: "Qué es AT", s: "done" },
                    { l: "M2", t: "Anatomía", s: "done" },
                    { l: "M3", t: "Tendencias", s: "now" },
                    { l: "M4", t: "S/R", s: "next" },
                    { l: "M5", t: "Volumen", s: "next" },
                    { l: "P",  t: "Proyecto", s: "future", proj: true },
                  ].map((m, i, arr) => (
                    <React.Fragment key={i}>
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", flexShrink: 0 }}>
                        <div style={{
                          width: 36, height: 36, borderRadius: m.proj ? 8 : 99,
                          border: `1.5px solid ${m.s === "done" ? "var(--m-positive)" : m.s === "now" ? "var(--m-primary)" : "var(--m-line-strong)"}`,
                          background: m.s === "done" ? "rgba(155,184,106,0.16)" :
                                      m.s === "now" ? "rgba(201,122,75,0.18)" : "var(--m-bg-deep)",
                          display: "grid", placeItems: "center",
                          color: m.s === "done" ? "var(--m-positive)" : m.s === "now" ? "var(--m-primary)" : "var(--m-text-3)",
                          fontFamily: "var(--m-t-mono)", fontSize: 11, fontWeight: 600,
                        }}>{m.l}</div>
                        <span className="mono" style={{ fontSize: 9.5, color: "var(--m-text-3)", marginTop: 6, letterSpacing: "0.04em" }}>{m.t}</span>
                      </div>
                      {i < arr.length - 1 && (
                        <div style={{
                          flex: 1, height: 2,
                          background: i < 1 ? "var(--m-positive)" : i < 2 ? "linear-gradient(90deg, var(--m-positive), var(--m-primary))" : "rgba(216,196,160,0.12)",
                        }}/>
                      )}
                    </React.Fragment>
                  ))}
                </div>
              </div>

              <div className="m-panel" style={{ padding: 18 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <MEye>Conceptos cercanos</MEye>
                  <a className="mono" style={{ fontSize: 10, color: "var(--m-text-3)" }}>ver grafo completo →</a>
                </div>
                <div style={{ marginTop: 8 }}>
                  <MConceptGraph nodes={conceptNodes} edges={conceptEdges} focus="tend" width={260} height={170}/>
                </div>
              </div>
            </div>
          </div>

          {/* footer with status */}
          <div style={{
            height: 36, padding: "0 40px",
            display: "flex", alignItems: "center", justifyContent: "space-between",
            borderTop: "1px solid var(--m-line)", background: "rgba(0,0,0,0.25)",
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
              <Icon name="shield" size={12} style={{ color: "var(--m-text-3)" }}/>
              <MNotAdvice>EducaFinaz · capa educativa de Finaz · contenido pedagógico, no asesoramiento</MNotAdvice>
            </div>
            <div className="mono" style={{ fontSize: 10, color: "var(--m-text-3)", display: "flex", gap: 12 }}>
              <span>session 24 · objetivo: comprensión + transferencia</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
